import { RefObject } from "react";
import { Alert } from "react-bootstrap";
import { PrimaryButton } from "components/Button/style";

interface ConfirmarPlacaProps {
  placa: string;
  inputRef: RefObject<HTMLInputElement>;
  onChange: (valor: string) => void;
  onConfirmar: (placa: string) => void;
  onVoltar: () => void;
}

export function ConfirmarPlaca({ placa, inputRef, onChange, onConfirmar, onVoltar }: ConfirmarPlacaProps) {
  return (
    <div className="text-center py-4">
      {placa ? (
        <>
          <p className="text-muted mb-2" style={{ fontSize: "0.9rem" }}>Placa identificada:</p>
          <div
            style={{
              display: "inline-block",
              border: "4px solid #1a1a1a",
              borderRadius: 12,
              padding: "12px 32px",
              background: "#fff",
              marginBottom: 24,
            }}
          >
            <span style={{ fontSize: "4rem", fontWeight: 800, letterSpacing: 8, fontFamily: "monospace", color: "#1a1a1a" }}>
              {placa}
            </span>
          </div>
        </>
      ) : (
        <Alert variant="warning" className="mb-3">
          Não foi possível identificar a placa automaticamente. Digite manualmente.
        </Alert>
      )}

      <div className="mb-3">
        <label style={{ fontWeight: 600, marginBottom: 6, display: "block" }}>
          Confirme ou corrija a placa:
        </label>
        <input
          ref={inputRef}
          type="text"
          className="form-control text-center"
          style={{ fontSize: "1.8rem", fontWeight: 700, letterSpacing: 4, maxWidth: 280, margin: "0 auto", textTransform: "uppercase" }}
          value={placa}
          maxLength={8}
          onChange={(e) => onChange(e.target.value.toUpperCase())}
          onKeyDown={(e) => { if (e.key === "Enter" && placa.trim()) { onConfirmar(placa.trim()); } }}
          autoFocus
        />
      </div>

      <div className="d-flex justify-content-center gap-2 mt-3">
        <PrimaryButton outline variante="primary" onClick={onVoltar}>Repetir</PrimaryButton>
        <PrimaryButton disabled={!placa.trim()} onClick={() => onConfirmar(placa.trim())}>Confirmar</PrimaryButton>
      </div>
    </div>
  );
}
